import { useSelector } from 'react-redux';
import { hasPermission } from 'utils/permissions';

const getActionItems = (services, selectedRow) => {
  return [
    {
      label: 'Submit',
      onClick: () => services.submitLCRecord(selectedRow?.lifeCycleCaseRecord),
      icon: '',
      permissions: ['ROLE_BASE_PERMISSION_EMPLOYEE_INDEX_SUBMIT_LIFECYCLE_CASE_RECORD'],
      conditional: (row) => row?.lifeCycleCaseRecord?.status === 'Draft',
    },
    {
      label: 'Delete',
      onClick: services.handleDeleteDialog,
      icon: '',
      color: 'error.400',
      permissions: ['ROLE_BASE_PERMISSION_EMPLOYEE_INDEX_DELETE_CASE_RECORD'],
      conditional: (row) =>
        row?.lifeCycleCaseRecord?.status === 'Approval Pending' || row?.lifeCycleCaseRecord?.status === 'Draft',
    },
    {
      label: 'Action Case Record',
      onClick: () => services.actionEmployee(selectedRow?.lifeCycleCaseRecord),
      icon: '',
      permissions: ['ROLE_BASE_PERMISSION_EMPLOYEE_INDEX_ACTION_LIFECYCLE_CASE_RECORD'],
      conditional: (row) => row?.lifeCycleCaseRecord?.status === 'Approval Pending',
    },
  ];
};

const useMenuItems = (row, services) => {
  const actions = getActionItems(services, row);
  const authorities = useSelector((state) => state.session.user.authorities);

  const moreFilteredActionItems = actions.filter((action) => {
    const userHasPermission = hasPermission(authorities, action.permissions);
    if ((action.conditional && !action.conditional(row)) || !userHasPermission) {
      return false;
    }
    return true;
  });
  return [moreFilteredActionItems];
};

export default useMenuItems;
